import Reflux from 'reflux';

export default Reflux.createActions([
  'updateProjects',
  'updateDateTime',
  'updateEnvironments',
]);
